import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, PhoneCall, X, Globe } from 'lucide-react';
import { Button } from '../ui/button';

const PHONE_NUMBER = '+17869813760';
const PHONE_DISPLAY = '(786) 574-2905';

export default function VoiceWidget() {
  // This widget is now disabled - only WhatsApp and Chat buttons are shown
  // Keeping the component for potential future use
  return null;
}
